export default function initVideoSrc() {

    const videoIframe = document.querySelector('[data-video]');
    if(videoIframe) {
        const videoSrc = videoIframe.getAttribute('data-src');
        const videoSrcMobile = videoIframe.getAttribute('data-src-mobile');

        videoIframe.setAttribute('src', getVideoSrc(videoSrc, videoSrcMobile));
        window.addEventListener('resize', (e)=> {
            videoIframe.setAttribute('src', getVideoSrc(videoSrc, videoSrcMobile));
        });
    }

    function getVideoSrc(videoSrc, videoSrcMobile) {
        return window.innerWidth <= 1024 ? videoSrcMobile : videoSrc;
    }

}
